import React from "react";

import connect from "glassRedux/connect";
import store from "glassRedux/store";
import { bindActionCreators } from "glassRedux/connect";

import { persist, RESET_STATE } from "glassRedux/offline";

import { DateHelper } from "shared/helpers/DateHelper.js";

import {
  fetchPlan,
  setHasBlankTask,
  addBlankTask,
  newTaskSet,
  saveNewTask,
  setNeedsScrollAlignment,
} from "shared/itemLists/redux/itemListsSlice";

import { insertionIndex } from "shared/itemLists/CursorItemsCoordinator/functions/cursorFunctions";

import {
  tokenSet,
  setPrimaryCalendarId,
  setNeedsReset,
} from "shared/auth/redux/authSlice";

import nativeStorage from "utils/localStorage";

class AppShared extends React.Component {
  constructor(props) {
    super(props);
    this.localStorage =
      typeof navigator != "undefined" && navigator.product == "ReactNative"
        ? nativeStorage
        : localStorage;
    const fixedDate = props.fixedDate || new Date();
    this.state = this.initialState(fixedDate);
    this.readOnlyState = ["dateHelper", "lastDay", "currentTimeInMinutes"];
    this.stateSetterStrings().forEach((setterFuncName) => {
      this[setterFuncName] = this[setterFuncName].bind(this);
    });
    this.handleNewTaskButtonClick = this.handleNewTaskButtonClick.bind(this);
    this.resetAppState = this.resetAppState.bind(this);
    this.sharedMainListViewProps = this.sharedMainListViewProps.bind(this);
  }

  initialState(fixedDate) {
    return {
      selectedDate: DateHelper.makeJustDay(fixedDate),
      dateHelper: new DateHelper(DateHelper.makeJustDay(fixedDate)),
      lastDay: DateHelper.dateString(fixedDate),
      isLoggedIn: this.localStorage.getItem("isLoggedIn") === "true",
      canEnterItem: true,
      listType: "Plan",
      currentTimeInMinutes: fixedDate.getHours() * 60 + fixedDate.getMinutes(),
      openChecklist: { isOpen: false },
      isSomeday: false,
      scrollOffset: 0,
      cursorIndex: 0,
      flashMessage: { message: "" },
    };
  }

  resetAppState() {
    this.setState(this.initialState(new Date()));
    persist(store, { blacklist: ["itemLists", "auth"] }).purge();
    this.localStorage.clear();
    store.dispatch({ type: RESET_STATE });
    store.dispatch({ type: "USER_LOGOUT" });
    this.setIsLoggedIn(false);
    store.dispatch(setNeedsReset(false));
  }

  setWithFunctionOrValue(_this, param, key) {
    if (typeof param === "function") {
      _this.setState((state) => {
        return { [key]: param(state[key]) };
      });
    } else {
      _this.setState({ [key]: param });
    }
  }

  setSelectedDate(value) {
    this.setWithFunctionOrValue(this, value, "selectedDate");
  }

  setIsLoggedIn(value) {
    this.setState({ isLoggedIn: value });
  }

  setCanEnterItem(value) {
    this.setState({ canEnterItem: value });
  }

  setListType(value) {
    this.setState({ listType: value });
    if (value !== "Done") {
      this.setState({ cursorIndex: 0 });
      store.dispatch(setNeedsScrollAlignment({ scrollTop: 0 }));
    }
  }

  setOpenChecklist(param) {
    this.setWithFunctionOrValue(this, param, "openChecklist");
  }

  setIsSomeday(value) {
    this.setState({ isSomeday: value });
  }

  setScrollOffset(value) {
    this.setState({ scrollOffset: value });
  }

  setCursorIndex(param) {
    this.setWithFunctionOrValue(this, param, "cursorIndex");
  }

  setFlashMessage(value) {
    this.setState({ flashMessage: value });
  }

  setToken(tokenParam) {
    store.dispatch(tokenSet(tokenParam));
  }

  stateSetterStrings() {
    return Object.keys(this.state).reduce((acc, key) => {
      if (!this.readOnlyState.includes(key)) {
        return acc.concat("set" + key.charAt(0).toUpperCase() + key.slice(1));
      } else {
        return acc;
      }
    }, []);
  }

  stateSetters() {
    return this.stateSetterStrings().reduce(
      (acc, str) => ({
        ...acc,
        [str]: this[str],
      }),
      {}
    );
  }

  setters() {
    return {
      ...this.stateSetters(),
      setToken: this.setToken,
      handleNewTaskButtonClick: this.handleNewTaskButtonClick,
      resetAppState: this.resetAppState,
    };
  }

  componentDidMount() {
    this.props.fetchPlan();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoggedIn, listType, openChecklist, canEnterItem } = this.state;
    const {
      token,
      openItem,
      timeCorrectionObject,
      newTask,
      isAddingTaskWithEnter,
      needsReset,
    } = this.props;

    if (needsReset) {
      this.resetAppState();
    }
    if (isLoggedIn !== prevState.isLoggedIn) {
      this.localStorage.setItem("isLoggedIn", isLoggedIn);
    }
    if (token !== prevProps.token || isLoggedIn !== prevState.isLoggedIn) {
      if (token && isLoggedIn) {
        console.log("this ran, token is not undefined");
        this.props.fetchPlan();
      }
    }

    let bool =
      isLoggedIn &&
      listType !== "Done" &&
      !openChecklist.isOpen &&
      !openItem.isOpen &&
      !timeCorrectionObject.isOpen &&
      !newTask.initiated &&
      !isAddingTaskWithEnter;
    if (bool !== canEnterItem) {
      this.setCanEnterItem(bool);
    }
  }

  handleNewTaskButtonClick() {
    const { listType, selectedDate, cursorIndex } = this.state;
    let position;
    if (listType === "Plan") {
      position = insertionIndex(cursorIndex, this.props.planItems);
    } else {
      position = cursorIndex;
    }
    this.props.addBlankTask({ position, selectedDate, listType });
    this.setCursorIndex(position + 1);
  }

  sharedMainListViewProps() {
    const {
      listType,
      selectedDate,
      dateHelper,
      currentTimeInMinutes,
      cursorIndex,
    } = this.state;
    const { setOpenChecklist } = this;
    const {
      planItems,
      dueItems,
      token,
      fetchPlan,
      newTask,
      hasBlankTask,
      setHasBlankTask,
    } = this.props;

    const { setListType, setSelectedDate, setCursorIndex } = this;
    return {
      ...{
        listType,
        setListType,
        selectedDate,
        setSelectedDate,
        planItems,
        dueItems,
        token,
        fetchPlan,
        dateHelper,
        currentTimeInMinutes,
        newTask,
        hasBlankTask,
        setHasBlankTask,
        setOpenChecklist,
        cursorIndex,
        setCursorIndex,
      },
      setNewTask: newTaskSet,
    };
  }

  render() {
    return this.props.renderApp({
      ...this.props,
      ...this.state,
      ...this.setters(),
      sharedMainListViewProps: this.sharedMainListViewProps(),
    });
  }
}

function mapStateToProps(state) {
  return {
    planItems: state.itemLists.items,
    doneItems: state.itemLists.doneItems,
    dueItems: state.itemLists.dueItems,
    openItem: state.itemLists.openItem,
    token: state.auth.token,
    isAddingTaskWithEnter: state.itemLists.insertStatus.isAddingTaskWithEnter,
    hasBlankTask: state.itemLists.insertStatus.hasBlankTask,
    newTask: state.itemLists.newTask,
    timeCorrectionObject: state.itemLists.timeCorrectionObject,
    needsReset: state.auth.needsReset,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchPlan,
      addBlankTask,
      newTaskSet,
      setHasBlankTask,
      saveNewTask,
      setPrimaryCalendarId,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AppShared);
